export * from "ce/reducers/uiReducers/editorReducer";
import { default as CE_editorReducer } from "ce/reducers/uiReducers/editorReducer";
export default CE_editorReducer;
